// ========================================
// API CONFIGURATION - GEMINI API (VIA NETLIFY FUNCTIONS)
// ========================================

const GEMINI_CONFIG = {
    // La API Key ahora se maneja en el backend (Netlify Function)
    apiKey: '', // Ya no se usa en el cliente

    // Endpoint de la Function de Netlify
    // Detectar si estamos en local o producci�n
    endpoint: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
        ? '/.netlify/functions/gemini'
        : '/.netlify/functions/gemini',

    // Modelo a usar (configurado por defecto en el backend, pero �til para referencia)
    model: 'gemini-2.5-flash',
};

/**
 * Verifica si la configuraci�n es v�lida
 * (En este caso, siempre retornamos true porque la key est� en el servidor)
 */
function isApiKeyConfigured() {
    return true;
}

/**
 * Genera texto usando la API de Gemini via Netlify Function
 * @param {string} prompt - El prompt para generar texto
 * @param {string} systemInstruction - Instrucci�n del sistema (opcional)
 * @returns {Promise<string>} El texto generado
 */
async function generateText(prompt, systemInstruction = '') {
    const url = GEMINI_CONFIG.endpoint;

    const requestBody = {
        prompt: prompt,
        systemInstruction: systemInstruction
    };

    try {
        console.log('Llamando a Gemini via Netlify...');
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(`API Error: ${response.status} - ${JSON.stringify(errorData)}`);
        }

        const data = await response.json();

        // La estructura devuelta por la funci�n Netlify debe coincidir con la de Gemini
        // O la funci�n puede devolver ya el texto procesado. 
        // Revisando netlify/functions/gemini.js, devuelve la respuesta de Gemini completa.

        if (!data.candidates || data.candidates.length === 0) {
            throw new Error('No se gener� ninguna respuesta');
        }

        const generatedText = data.candidates[0].content.parts[0].text;
        return generatedText;
    } catch (error) {
        console.error('Error al generar texto con Gemini (Netlify):', error);
        throw error;
    }
}

/**
 * Genera JSON usando la API de Gemini via Netlify Function
 * @param {string} prompt - El prompt para generar JSON
 * @param {string} systemInstruction - Instrucci�n del sistema (opcional)
 * @returns {Promise<Object>} El objeto JSON parseado
 */
async function generateJSON(prompt, systemInstruction = '') {
    const url = GEMINI_CONFIG.endpoint;

    const requestBody = {
        prompt: prompt,
        systemInstruction: systemInstruction,
        responseFormat: 'json' // Indicamos al backend que queremos JSON
    };

    try {
        console.log('Solicitando JSON a Gemini via Netlify...');
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(`API Error: ${response.status} - ${JSON.stringify(errorData)}`);
        }

        const data = await response.json();

        if (!data.candidates || data.candidates.length === 0) {
            throw new Error('No se gener� ninguna respuesta');
        }

        // Obtener el texto de la respuesta
        let jsonText = data.candidates[0].content.parts[0].text;

        // Limpiar la respuesta para extraer solo el JSON si es necesario
        // (Aunque el modelo suele ser bueno, es mejor asegurarse)
        jsonText = jsonText.trim();
        jsonText = jsonText.replace(/```json\n?/g, '').replace(/```\n?/g, '');

        try {
            return JSON.parse(jsonText);
        } catch (error) {
            console.error('Error parseando JSON:', error);
            console.error('Texto recibido:', jsonText);
            throw new Error('La API no retorno JSON valido');
        }
    } catch (error) {
        console.error('Error al generar JSON con Gemini (Netlify):', error);
        throw error;
    }
}

/**
 * Funcion generica para llamar a la API de Gemini
 * Alias de generateText para compatibilidad con agentes multi-agente
 * @param {string} prompt - El prompt para la API
 * @param {string} systemInstruction - Instruccion del sistema (opcional)
 * @returns {Promise<string>} La respuesta de la API
 */
async function callGeminiAPI(prompt, systemInstruction = '') {
    return await generateText(prompt, systemInstruction);
}

// Exportar configuracion y funciones al objeto window
if (typeof window !== 'undefined') {
    window.GEMINI_CONFIG = GEMINI_CONFIG;
    window.isApiKeyConfigured = isApiKeyConfigured;
    window.generateText = generateText;
    window.generateJSON = generateJSON;
    window.callGeminiAPI = callGeminiAPI;

    console.log('API de Gemini (Netlify Proxy) cargada correctamente');
    console.log('Mode: Secure Backend');
}
